// components/ColorSchemeToggle.tsx

import React from 'react';
import { Button } from '@mantine/core';
import { IconMoon, IconSun } from '@tabler/icons-react';

interface ColorSchemeToggleProps {
  colorScheme: 'light' | 'dark';
  toggleColorScheme: () => void;
}

export const ColorSchemeToggle: React.FC<ColorSchemeToggleProps> = ({
  colorScheme,
  toggleColorScheme,
}) => (
  <Button
    variant="transparent"
    color={colorScheme === 'light' ? 'white' : 'gray'}
    onClick={toggleColorScheme}
    fullWidth
    miw={'40%'}
    className="color-scheme-toggle"
  >
    {colorScheme === 'light' ? (
      <IconMoon color="black" />
    ) : (
      <IconSun color="white" />
    )}
  </Button>
);
